import React,{ useEffect,useState } from 'react';
import {appGetUrlPath} from '../function_lib/common_lib';
import './comp_request_card.css'

const Comp_Request_Card=(props)=>{
    const [reqStatus,setReqStatus]=useState("");
    let appUrlMedPath=appGetUrlPath();
    useEffect(()=>{

    },[props.member]);
    return(
   
<div class="cards-wrapper-digital-sewa">

  <div class="rc digisewacard">
    <div class="hdr">
      <div class="left">
        <span class="rid">Request ID</span>
        <span class="rnum">#{props.member["id"]}</span>
        <span class="rdate">
          <i class="fa fa-calendar-days" style={{ fontSize: '10px' }}></i>
          {props.member["request_date"]}
        </span>
      </div>
      {props.member["process_status"]==="Completed"?<span class="status-badge status-completed"><span class="dot"></span>{props.member["process_status"]}</span>:''}
      {props.member["process_status"]!=="Completed"?<span class="status-badge status-pending"><span class="dot"></span>{props.member["process_status"]}</span>:''}
       {/* <span class="status-badge status-inprogress"><span class="dot"></span>In Progress</span>
       <span class="status-badge status-reject"><span class="dot"></span>Rejected</span>
        <span class="status-badge status-completed"><span class="dot"></span>Completed</span> */}
    </div>
    <div class="body">
      <div class="svc-row">
        <div class="svc-icon"><i class="fa fa-id-card"></i></div>
        <div>
          <div class="svc-title">{props.member["category_name"]}</div>
        </div>
      </div>
      <div class="fields">
      {JSON.parse(props.member?.form_request)?.map((formItem,formIndex)=>{
         if(formItem.field_type==="text"){
        return  <div class="field">
        <div class="fl">{formItem["field_name"]}</div>
        <div class="fv">{formItem["value"]}</div>
      </div>
         }
      })
    }
        
       
        
      </div>
      <div class="meta-row">
        {/* <div class="meta-chip">
          <i class="fa fa-mobile" style={{color:'#1d4ed8'}}></i>
          <span class="mv">9826490915</span>
        </div> */}
        <div class="meta-chip">
          <i class="fa fa-inr" style={{color:'#64748b'}}></i>
          Total: <span class="mv">{props.member["service_cost"]}</span>
        </div>
        <div class="meta-chip">
          <i class="fa fa-check-circle-o" style={{color:'#15803d'}}></i>
          Paid: <span class="mv paid">₹{props.member["service_cost"]}</span>
        </div>
      </div>
      {(props.member["process_status"]==="Rejected" || props.member["process_status"]==="canceled")?
      <div class="alert-bar">
        Reason: <i class="fa fa-triangle-exclamation"></i>
        {props.member["process_desc"]}
      </div>:''}
      <div class="aknowlegment">Aknowlegment No.: <span class="rid">#{props.member["ack_no"]}</span></div>
      <div class="actions">
        <button onClick={()=>props.onViewProfile(props.member)} class="btn btn-view"  data-bs-toggle="modal"
      data-bs-target="#profileModal"   type="button"><i class="fa fa-eye"></i> View/Process form</button>
      {props.member?.doc_release!==""?
        <a class="btn btn-view"  target='blank' href={appUrlMedPath+props.member?.doc_release} ><i class="fa fa-download"></i> Download</a>:''}
        <a onClick={()=>props.onViewProfile(props.member)} href={"javascript:void(0)"} class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#divEditFromDigitalSevaNew" ><i class="fa fa-pencil"></i> Edit</a>
        <button class="btn btn-ghost"   type="button"><i class="fa fa-trash"></i> Cancel</button>
      </div>
    </div>
  </div>

 


</div>


    )
}
export default  Comp_Request_Card;